module.exports = __webpack_public_path__ + "img/two-code.d669e910.jpg";